import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';

import {VaultProfileSigninFlowService} from '../services/vault-profile-signin-flow.service';

export const hasCompletedSigninWelcomeGuard: CanActivateFn = () => {
  const signinFlowService = inject(VaultProfileSigninFlowService);
  const router = inject(Router);

  return signinFlowService.hasCompletedWelcome()
    ? true
    : router.createUrlTree(['/auth/signin']);
};
